namespace GeniuzPOS.Inventory {
    export enum PostFgsStatus {
        UnPost = 0,
        Posted = 1
    }
    Serenity.Decorators.registerEnumType(PostFgsStatus, 'GeniuzPOS.Inventory.PostFgsStatus');
}
